import { useEffect } from 'react';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import type { ControlKey } from './product-model';
import { productDefaults } from './slide-model';

/** После загрузки формы заполняет пустые опубликованные выборы: умолчание формы, затем умолчание спецификации.
    Восстановленный повтор и уже выбранное не трогаются; при неизменном вводе setInputs не вызывается. */
export function useProductDefaults(state: CircleFormState, defaults: Array<[ControlKey, string[]]>) {
  const { form, inputs, intent, setInputs } = state;
  const missing = productDefaults(form, inputs, defaults);
  const key = JSON.stringify(missing);
  useEffect(() => {
    if (intent || !missing.length) return;
    setInputs(previous => {
      const next = { ...previous };
      for (const [field, value] of missing) if (!next[field]) next[field] = value;
      return next;
    });
    // Набор недостающих значений полностью описан ключом.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, intent]);
}
